var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinSlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.345 20.595L8.47 14.47q.219-.22.53-.22t.53.22q.22.219.22.53t-.22.53l-6.125 6.125q-.219.22-.53.22t-.53-.22q-.22-.219-.22-.53t.22-.53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.72 11.97l.358-.358a6.7 6.7 0 0 1 2.326-1.518l1.896-.738a.25.25 0 0 0 .086-.409l-6.333-6.333a.25.25 0 0 0-.409.086l-.521 1.34a8.66 8.66 0 0 1-2.243 3.265a.75.75 0 0 1-1.01-1.11a7.1 7.1 0 0 0 1.854-2.699l.521-1.34a1.75 1.75 0 0 1 2.869-.603l6.333 6.333a1.75 1.75 0 0 1-.603 2.869l-1.896.737a5.3 5.3 0 0 0-1.81 1.18l-.358.358a.749.749 0 1 1-1.06-1.06m-12.549-.738a1.75 1.75 0 0 1 .757-2.92l3.366-.962l.412 1.443l-3.366.961a.25.25 0 0 0-.108.417l8.597 8.597a.25.25 0 0 0 .417-.108l.961-3.366l1.443.412l-.962 3.366a1.75 1.75 0 0 1-2.92.757Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m3.405 2.095l18.75 18.75q.22.219.22.53t-.22.53t-.53.22t-.53-.22L2.345 3.155q-.22-.219-.22-.53t.22-.53q.219-.22.53-.22t.53.22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSlash);
export default __webpack_public_path__ + "static/media/pin-slash.eaf842d2d377792ca1f401faefebb72b.svg";
export { ForwardRef as ReactComponent };